export default __webpack_public_path__ + "static/media/wa_7.765df9bf.mp3";